import { render } from "./Slot.vue?vue&type=template&id=5978e2d2"
import script from "./Slot.vue?vue&type=script&lang=ts"
export * from "./Slot.vue?vue&type=script&lang=ts"
script.render = render

export default script